// import {
//     Button,
//     Divider,
//     Form,
//     Input,
//     message,
//     Space,
//     Tag,
//     Typography,
//     Modal
//   } from "antd";
//   import { ArrowLeftOutlined } from '@ant-design/icons';
//   import React, { useState, useRef } from "react";
//   import LoadingSpin from "../loadingSpin/LoadingSpin";
//   import ScanBarCode from "./ScanBarCode";
//   import "../../../src/App.css";
//   import { useNavigate } from "react-router";
// import ResponseMessage from "../Comman/Notification/ResponseMessge";
  
//   const { Title, Text } = Typography;
  
//   const EndLineDispatch = ({ userData }) => {
//     const [isSubmitted, setIsSubmitted] = useState(false);
//     const [scannedData, setScannedData] = useState("");
//     const [isLoading, setIsLoading] = useState(false);
//     const [isModalVisible, setIsModalVisible] = useState(false);
//     const [scannedValue, setScannedValue] = useState("");
//     const scannerRef = useRef(null);
//     const [startScan, setStartScan] = useState(false);
//     const navigate = useNavigate();
//     const [form] = Form.useForm();
  
//     const handleTagClick = () => {
//       setIsModalVisible(true);
//       setStartScan(true);
//       scannerRef.current?.startScanner();
//     };
  
//     const handleScan = (value) => {
//       onFinish(value);
//       setScannedValue(value);
//     };
  
//     const onFinish = async (values) => {
//       try {
//         const dataToSubmit = values.kb_number || values;
//         setScannedData(dataToSubmit);
  
//         if (!dataToSubmit) {
//           // message.error("Please provide valid scanned data or enter it manually");
//           ResponseMessage.error({ message: "Please provide valid scanned data or enter it manually" })
//           return;
//         }
  
//         setIsSubmitted(true);
//         setIsLoading(true);

//         navigate(`/eol-dispatch-kanban?kb_num=${encodeURIComponent(dataToSubmit)}`);
  
       
//       } catch (error) {
//         console.error('Error:', error);
//         setIsLoading(false);
        
//         ResponseMessage.error({ message:"An error occurred while fetching data." });
//         setIsSubmitted(false);
//       }
//     };
  
//     return (
//       <div>
//         <Title level={5} style={{ marginTop: -15, margin: 0 }}>
//               END of Line Dispatch
//         </Title>
  
//         <Divider style={{ marginTop: 8 }} />
  
//         {/* {!isSubmitted ? ( */}
//           <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//             <Tag
//               style={{
//                 width: "300px",
//                 height: "90px",
//                 color: "#2db7f5",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 backgroundColor: "#2db7f5",
//                 boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
//                 borderRadius: "10px",
//               }}
//               color="#2db7f5"
//               onClick={handleTagClick}
//             >
//               <Text strong style={{ fontSize: "20px", color: "white", fontWeight: "bold" }}>
//                 SCAN HERE
//               </Text>
//             </Tag>
  
//             <Space block size="large" style={{ padding: "20px 0" }}>
//               <Text strong>OR</Text>
//             </Space>
  
//             <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", width: "100%" }}>
//               <Form
//                 name="form_item_path"
//                 layout="vertical"
//                 onFinish={onFinish}
//                 form={form}
//                 style={{ width: "300px" }}
//               >
//                 <Form.Item name="kb_number" label="Enter Manually"
//                 rules={[
//                     {
//                         required: true,
//                         message: "ID cannot be empty. Please provide a valid ID."
//                     }
//                 ]}>
//                   <Input autoFocus size="large" style={{ width: "100%", textAlign: "center" }} />
//                 </Form.Item>
  
//                 <Form.Item>
//                   <div style={{ display: "flex", justifyContent: "center" }}>
//                     <Button type="primary" htmlType="submit">
//                       Submit
//                     </Button>
//                   </div>
//                 </Form.Item>
//               </Form>
//             </div>
//           </div>
//         {/* ) : isLoading ? (
//           <LoadingSpin />
//         ) :  null
//         }
//    */}
//         <Modal
//           destroyOnClose={true}
//           visible={isModalVisible}
//           onCancel={() => {
//             setIsModalVisible(false);
//             setStartScan(false);
//           }}
//           footer={null}
//           style={{ top: 20, display: "flex", justifyContent: "center" }}
//         >
//           <div>
//             <ScanBarCode
//               openCam={startScan}
//               ref={scannerRef}
//               onScan={(code) => {
//                 handleScan(code);
//                 setIsModalVisible(false);
//               }}
//               onStop={() => {
//                 setIsModalVisible(false);
//                 setStartScan(false);
//               }}
//             />
//           </div>
//         </Modal>
//       </div>
//     );
//   };
  
//   export default EndLineDispatch;
  import {
  Button,
  Divider,
  Form,
  Input,
  Space,
  Tag,
  Typography,
  Modal,
  Card,
} from "antd";
import { ScanOutlined, EditOutlined } from "@ant-design/icons";
import React, { useState, useRef } from "react";
import LoadingSpin from "../loadingSpin/LoadingSpin";
import ScanBarCode from "./ScanBarCode";
import { useNavigate } from "react-router";
import ResponseMessage from "../Comman/Notification/ResponseMessge";

const { Text } = Typography;

const EndLineDispatch = ({ userData }) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [startScan, setStartScan] = useState(false);
  const scannerRef = useRef(null);
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const handleTagClick = () => {
    setIsModalVisible(true);
    setStartScan(true);
    scannerRef.current?.startScanner();
  };

  const handleScan = (value) => {
    onFinish(value);
  };

  const onFinish = async (values) => {
    try {
      const dataToSubmit = values.kb_number || values;

      if (!dataToSubmit) {
        ResponseMessage.error({ message: "Please provide valid data" });
        return;
      }

      setIsSubmitted(true);
      setIsLoading(true);

      navigate(`/eol-dispatch-kanban?kb_num=${encodeURIComponent(dataToSubmit)}`);
    } catch (error) {
      setIsLoading(false);
      ResponseMessage.error({ message: "Error occurred" });
      setIsSubmitted(false);
    }
  };

  return (
    <Card className="modern-card" title="Scan / Enter Kanban">
      
      <div style={{ textAlign: "center", padding: "20px 0" }}>
        
        {/* 🔹 Scan Card */}
        <div
          className="dashboard-stat-card bg-card-blue"
          style={{ maxWidth: 300, margin: "0 auto" }}
          onClick={handleTagClick}
        >
          <div className="dashboard-stat-card-inner">
            <ScanOutlined style={{ fontSize: 30 }} />
            <div className="dashboard-stat-title">SCAN HERE</div>
          </div>
        </div>

        <Space style={{ margin: "20px 0" }}>
          <Text strong>OR</Text>
        </Space>

        {/* 🔹 Manual Entry */}
        <Form
          layout="vertical"
          onFinish={onFinish}
          form={form}
          style={{ maxWidth: 300, margin: "0 auto" }}
        >
          <Form.Item
            name="kb_number"
            label="Enter Manually"
            rules={[
              { required: true, message: "Please enter valid ID" },
            ]}
          >
            <Input
              size="large"
              style={{ textAlign: "center" }}
              prefix={<EditOutlined />}
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              className="primary-btn"
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>

      {/* 🔹 Scanner Modal */}
      <Modal
        destroyOnClose
        open={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          setStartScan(false);
        }}
        footer={null}
        centered
      >
        <ScanBarCode
          openCam={startScan}
          ref={scannerRef}
          onScan={(code) => {
            handleScan(code);
            setIsModalVisible(false);
          }}
          onStop={() => {
            setIsModalVisible(false);
            setStartScan(false);
          }}
        />
      </Modal>

      {/* 🔹 Loader */}
      {isLoading && (
        <div className="dashboard-overlay-loader">
          <LoadingSpin />
        </div>
      )}
    </Card>
  );
};

export default EndLineDispatch;